import React from "react";
import { motion } from "framer-motion";
import "./Strategies.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faBullseye,
  faLayerGroup,
  faPenRuler,
  faGear,
  faArrowTrendUp,
} from "@fortawesome/free-solid-svg-icons";

const strategyItems = [
  {
    step: "01",
    icon: faChartLine,
    title: "Market Research & Competitive Audit",
    description:
      "We dissect your target audience, competitors, and current bottlenecks to uncover high-impact growth vectors—backed by data, not guesswork.",
    gradient: "linear-gradient(135deg, #d946ef 0%, #8b5cf6 100%)",
  },
  {
    step: "02",
    icon: faBullseye,
    title: "Positioning & Conversion Messaging",
    description:
      "We sharpen your value proposition and brand voice so ideal customers instantly understand your superiority and feel compelled to choose you.",
    gradient: "linear-gradient(135deg, #8b5cf6 0%, #2563eb 100%)",
  },
  {
    step: "03",
    icon: faLayerGroup,
    title: "Predictable Growth Architecture",
    description:
      "We architect a unified acquisition funnel uniting high-intent SEO, paid performance channels, and retention loops toward clear ROI milestones.",
    gradient: "linear-gradient(135deg, #2563eb 0%, #00d2ff 100%)",
  },
  {
    step: "04",
    icon: faPenRuler,
    title: "Experience & Interface Engineering",
    description:
      "Every page, micro-interaction, and call-to-action is meticulously designed to eliminate friction, answer objections, and accelerate conversions.",
    gradient: "linear-gradient(135deg, #ec4899 0%, #d946ef 100%)",
  },
  {
    step: "05",
    icon: faGear,
    title: "Lead Automation & CRM Pipelines",
    description:
      "We integrate modern tracking, instant notifications, automated nurturing, and attribution analytics so no high-value inquiry is ever lost.",
    gradient: "linear-gradient(135deg, #d946ef 0%, #2563eb 100%)",
  },
  {
    step: "06",
    icon: faArrowTrendUp,
    title: "Iterative Testing & Compounding Scale",
    description:
      "Post-launch, we run continuous A/B tests, keyword expansions, and campaign optimizations so your client acquisition compounds month over month.",
    gradient: "linear-gradient(135deg, #7c3aed 0%, #00d2ff 100%)",
  },
];

const Strategies = () => {
  return (
    <section className="sg-about" aria-label="Our growth strategy">
      <div className="sg-about-wrap">
        <motion.header
          className="sg-about-head"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="sg-about-kicker">Strategic Blueprint</span>
          <h2>A Systematic Framework Engineered for Scale</h2>
          <p>
            We eliminate trial-and-error by deploying an end-to-end framework
            that turns brand vision into predictable, compounding revenue.
          </p>
        </motion.header>

        <div className="sg-about-grid">
          {strategyItems.map((item, idx) => (
            <motion.article
              className="sg-about-card"
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
              whileHover={{ y: -5, transition: { duration: 0.2 } }}
            >
              <div className="sg-card-top">
                <span className="sg-step-number">{item.step}</span>
                <div
                  className="sg-about-icon"
                  style={{ background: item.gradient }}
                >
                  <FontAwesomeIcon icon={item.icon} />
                </div>
              </div>

              <div className="sg-card-body">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>

              <div className="sg-card-border" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Strategies;
